module.exports = __webpack_public_path__ + "static/media/policiaVila.6bb37872.png";